﻿module PortalLibs.Client.Components.Tooltip


open Feliz

type TooltipPosition =
  | Left
  | Top
  | Right
  | Bottom

let divWithTooltip tooltip positionOpt element =
  Html.div [
    Bulma.tooltip.text tooltip
    match positionOpt with
    | Some Left -> Bulma.tooltip.hasTooltipLeft
    | Some Top -> Bulma.tooltip.hasTooltipTop
    | Some Right -> Bulma.tooltip.hasTooltipRight
    | Some Bottom -> Bulma.tooltip.hasTooltipBottom
    | _ -> ()
    prop.children [ element ]
  ]


let spanWithTooltip (text: string) tooltip =
  Html.span [
    Bulma.tooltip.text tooltip
    prop.text text
  ]
